import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuid } from 'uuid';
import { getMaterialAssets } from '@/i18n/assets';
import {
    ImgCategoryType,
    ImgModeType,
    LayerType,
    MaskType,
    MaterialIdsType,
    StretchOptionType,
    type IImageLayerProps,
    type IImageTransform,
    type ILayerProps,
} from '@/version-types';

/** 获取与当前资源环境匹配的默认蒙版图片信息。 */
export const getDefaultMaskImageData = () => ({
    /** 默认蒙版图片地址。 */
    url: getMaterialAssets().imageLayer.maskURL,
    /** 默认蒙版素材宽度。 */
    width: 548,
    /** 默认蒙版素材高度。 */
    height: 493,
});

export const defaultImageTransform: IImageTransform = {
    // 横向偏移
    offsetX: 0,
    // 纵向偏移
    offsetY: 0,
    rotate: 0,
    scale: 1,
    // 水平翻转
    flipH: false,
    // 垂直翻转
    flipV: false,
    // 图片宽度相对于外框的原始比例
    widthRatio: 1,
    // 图片高度相对于外框的原始比例
    heightRatio: 1,
};

const defaultImageLayerData = {
    id: uuid(),
    layerType: LayerType.IMAGE_LAYER,
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    rotate: 0,
    opacity: 1,
    title: '',
    materialIds: {},
    isAILayer: false,
    data: {
        cutoutMaskURL: '',
        url: '',
        stretchOption: StretchOptionType.fill,
        naturalWidth: 0,
        naturalHeight: 0,
        /** 蒙版图片 */
        maskURL: '',
        /** 蒙版类型 */
        maskType: MaskType.none,
        imageTransform: defaultImageTransform,
        filter: null,
        effect: null,
        aiTextExtension: null,
        maskFeathering: 0,
        minimumMask: false,
    },
    lock: false,
    children: [],
    shine: true,
    hidden: false,
    mode: ImgModeType.none,
    category: ImgCategoryType.material,
    fitWidth: 0,
    fitHeight: 0,
} as ILayerProps;

export const getDefaultImageLayerData = (
    url: string,
    width: number,
    height: number,
    left: number,
    top: number,
    materialId?: string | Record<string, string[]>,
    natureWidth?: number,
    natureHeight?: number,
    isPhoto?: boolean,
) => {
    const imageLayerData = cloneDeep(defaultImageLayerData);
    const data = imageLayerData.data as IImageLayerProps;

    imageLayerData.id = uuid();
    data.url = url;
    data.naturalHeight = natureHeight ? natureHeight : height;
    data.naturalWidth = natureWidth ? natureWidth : width;
    imageLayerData.width = width;
    imageLayerData.height = height;
    imageLayerData.left = left;
    imageLayerData.top = top;

    if (materialId) {
        if (typeof materialId === 'string') {
            imageLayerData.materialIds = imageLayerData.materialIds || {};
            imageLayerData.materialIds[isPhoto ? MaterialIdsType.PHOTO_MATERIAL : MaterialIdsType.IMAGE_MATERIAL] = [
                materialId,
            ];
        } else {
            imageLayerData.materialIds = materialId;
        }
    }
    return imageLayerData;
};
